/*
 * LSP-21107: since Release 101 the Contact API requires an anonymous caller to prove it belongs to the
 * conversation before it mints a Zoom token (POST /public/token) or ends the call
 * (PUT /public/conversations/:id/end). The beacon never holds a participantId, so its proof is the
 * conversation token returned by its own POST /form-submissions/public plus the visitorId it generated.
 * Missing either one, the API answers 401 and the visitor is stuck on "Connecting".
 */

export interface VisitorCredentials {
  conversationId: string
  conversationToken: string | undefined
  visitorId: string
}

/** The conversation token from the POST /form-submissions/public response body, if present. */
export function readConversationToken(responseBody: unknown): string | undefined {
  if (!responseBody || typeof responseBody !== 'object') {
    return undefined
  }
  const token = (responseBody as { token?: unknown }).token
  return typeof token === 'string' && token !== '' ? token : undefined
}

/** Body for POST /public/token. The API derives the role itself, so no owner flag is sent. */
export function buildMeetingTokenRequest(credentials: VisitorCredentials & { username: string }) {
  return {
    conversationId: credentials.conversationId,
    conversationToken: credentials.conversationToken,
    visitorId: credentials.visitorId,
    username: credentials.username,
    provider: 'zoom'
  }
}

/** Body for PUT /public/conversations/:id/end. */
export function buildEndConversationRequest(credentials: VisitorCredentials) {
  return {
    conversationId: credentials.conversationId,
    conversationToken: credentials.conversationToken,
    visitorId: credentials.visitorId
  }
}
